import React, {useState} from "react";
import TaskMainContainer from "./TaskMainContainer";
import '../styles/logicWheel2.css';

import dragImg1 from "../images/arrangeByColumns/GreeceBlocks_4_1_1.png";
import dragImg2 from "../images/arrangeByColumns/GreeceBlocks_4_1_2.png";
import dragImg3 from "../images/arrangeByColumns/GreeceBlocks_4_1_3.png";

import ArrangeByColumns from "./ArrangeByColumns";
import bgNature from '../images/greece-flowers-bg.png';


const GreeceBlocks5 = (props) => {
  const [allComplete, setAllComplete] = useState(false);
  const [completedTaskCount, setCompletedTaskCount] = useState(0);

  const chooseTasks = [
    {
      title: 'Active vocabulary',
      columnsItems: [
        {id: 1, successAnswerId: 2, title: "Fixed pulley"},
        {id: 2, successAnswerId: 3, title: "Movable pulley"},
        {id: 3, successAnswerId: 1, title: "Compound pulley"},
      ],
      dragItems: [
        {id: 1, image: dragImg2},
        {id: 2, image: dragImg3},
        {id: 3, image: dragImg1},
      ]
    },
    {
      title: 'Active vocabulary',
      columnsItems: [
        {id: 1, successAnswerId: 2, title: "Fixed pulley"},
        {id: 2, successAnswerId: 3, title: "Movable pulley"},
        {id: 3, successAnswerId: 1, title: "Compound pulley"},
      ],
      dragItems: [
        {id: 1, mainText: "A systems which combines two or more pulleys"},
        {id: 2, mainText: "A pulley which only changes the direction of you pull, but doesn’t change the effort"},
        {id: 3, mainText: "A pulley which makes your effort twice easier"},
      ]
    },
  ]

  return (
    <TaskMainContainer
      lessonCode={props.lessonCode}
      tasksCount={chooseTasks.length}
      completeCount={completedTaskCount}
      setCompletedTaskCount={setCompletedTaskCount}
      taskComplete={allComplete}
    >
      <div className={'logic-wheel-2'}>
        {
          chooseTasks.map((item, i) => (
            <React.Fragment key={`step${i}`}>
              {
                ((completedTaskCount === (i)) || ((i+1) === chooseTasks.length && completedTaskCount >= chooseTasks.length)) ? (
                  <ArrangeByColumns
                    lang={'en'}
                    bgImg={bgNature}
                    title={item.title}
                    columns={item.columnsItems}
                    dragItems={item.dragItems}
                    taskComplete={() => {
                      setCompletedTaskCount(prevState => prevState + 1);
                      if ((i + 1) === chooseTasks.length) {
                        setAllComplete(true);
                      }
                    }}
                  />
                ) : null
              }
            </React.Fragment>
          ))
        }
      </div>
    </TaskMainContainer>
  )
}
export default GreeceBlocks5;
